<div class="fullcontainer">
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Driver Absence was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit Driver Absence - {{ this.driverAbsence.driver.firstName }} {{ this.driverAbsence.driver.lastName }}</h1>
    <app-audit-line [data]='this.driverAbsence'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-driver-absence-form [driverAbsence]='this.driverAbsence'></app-driver-absence-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/drivers/absence'>Cancel</button>
    </form>
  </div>
</div>
